import { formatNumber } from "../../config/trading";
import { TableHeader } from "./TableHeader";

const OKX_ASSET_COLUMNS = ["Asset", "Available", "Total"];

function BalanceRows({ balances, type }) {
  if (!balances.length) {
    return <div className="empty" data-testid={`okx-${type}-assets-empty`}>No {type} assets synced</div>;
  }
  return balances.map((item) => (
    <div className="asset-row" key={`${type}-${item.asset}`} data-testid={`okx-${type}-${item.asset.toLowerCase()}-row`}>
      <span>{item.asset}</span>
      <span className="mono">{formatNumber(item.available, 8)}</span>
      <strong className="mono">{formatNumber(item.total, 8)}</strong>
    </div>
  ));
}

export function OkxAssetList({ okxAssets }) {
  return (
    <div className="panel okx-assets-panel" data-testid="okx-assets-panel">
      <div className="panel-head"><span className="label">OKX ASSETS</span></div>
      {!okxAssets.configured && <div className="empty" data-testid="okx-assets-not-configured">Connect OKX to sync trading and funding assets</div>}
      {okxAssets.error && <div className="notice" data-testid="okx-assets-error">{okxAssets.error}</div>}
      {okxAssets.configured && !okxAssets.error && (
        <>
          <div className="asset-subhead" data-testid="okx-trading-assets-title">TRADING</div>
          <div className="table-like"><TableHeader variant="asset" testId="okx-trading-table-header" columns={OKX_ASSET_COLUMNS} /><BalanceRows balances={okxAssets.trading} type="trading" /></div>
          <div className="asset-subhead" data-testid="okx-funding-assets-title">FUNDING</div>
          <div className="table-like"><TableHeader variant="asset" testId="okx-funding-table-header" columns={OKX_ASSET_COLUMNS} /><BalanceRows balances={okxAssets.funding} type="funding" /></div>
        </>
      )}
    </div>
  );
}